import { useEffect, useState } from 'react';
import authenticationApi from '../../../api/authentication';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import htmr from 'htmr';
import { IChangePassword } from '../account-settings-models/interface';

const useAccountChangePassword = () => {
  const [apiError, setApiError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required('Old Password is required'),
    password: Yup.string()
      .required('Password is required')
      .min(6, 'Password is invalid'),
    confirmPassword: Yup.string().required('Confirm Password is required'),
  });

  const handleSubmit = async (values: IChangePassword) => {
    try {
      if (values.password !== values.confirmPassword) {
        return handleApiError('Password and Confirm Password do not match');
      }
      if (values.oldPassword === values.password) {
        return handleApiError(
          'Old Password and New Password cannot be the same'
        );
      }

      handleApiError('');
      setIsLoading(true);
      const res = await authenticationApi.resetPassword({
        userName: values.userName,
        password: values.password,
        userType: values.userType,
      });
      if (res.success) {
        toast.success('Password reset successful.');
        formik.resetForm();
      } else {
        handleApiError(htmr(res.description) as string);
      }
    } catch (e) {
      handleApiError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };
  const formik = useFormik<IChangePassword>({
    initialValues: {
      userName: localStorage.getItem('c-username') || '',
      password: '',
      confirmPassword: '',
      userType: 1,
      oldPassword: '',
    },
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: false,
    validationSchema,
  });

  const handleApiError = (error: string) => {
    setApiError(error);
  };

  const handleCloseAlert = () => {
    setApiError('');
  };

  useEffect(() => {
    if (!localStorage.getItem('c-username')) {
      toast.error('User Information is not available');
    }
  }, []);

  return {
    formik,
    apiError,
    isLoading,
    handleCloseAlert,
  };
};

export default useAccountChangePassword;
